import AxiosInstance from './axios-instance';

export default class SimpleInjector {
    constructor(app) {
        this.app = app;
    }

    registerServices = ({ store, registrations }) => {
        for (const registration of registrations) {
            const [serviceType, serviceName] = registration;

            const axiosInstance = new AxiosInstance(this.app?.config?.globalProperties?.axios);
            const serviceInstance = new serviceType(axiosInstance);

            store[serviceName] = serviceInstance;
            this.app.provide(serviceName, serviceInstance);
        }
    }
}

const registrationHelper = (serviceType) => {
    return {
        as: function (serviceName) {
            return [serviceType, serviceName];
        },
    }
}

export {
    registrationHelper as register,
};